import { useMutation } from '@tanstack/react-query'
import { DateTime } from 'luxon'

import { steerResource } from '@/features/resource/endpoints/resources'
import type { ManualSteeringFormSchemaType } from '@/features/resource/types'
import { convertToWatts } from '@/features/resource/utils/convertToWatts'

export function useManualSteeringMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (variables: { resourceId: string; data: ManualSteeringFormSchemaType }) => {
      const submitData = {
        ...variables.data,
        targetConsumptionLevel:
          variables.data.steeringCommandType === 'RELEASE_CONTROL' || variables.data.targetConsumptionLevel === null
            ? null
            : convertToWatts(variables.data.targetConsumptionLevel),
        steerUntil: variables.data.steerUntil ? DateTime.fromJSDate(variables.data.steerUntil).toISO() : null,
      }
      return steerResource(variables.resourceId, submitData)
    },
  })

  return {
    steerResource: mutateAsync,
    ...mutationResult,
  }
}
